var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyInbox = function SvgMyInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 2.5H.833A.833.833 0 000 3.333v13.334c0 .46.373.833.833.833h18.334c.46 0 .833-.373.833-.833V3.333a.833.833 0 00-.833-.833zm-.42.833l-8.47 7.53a.417.417 0 01-.554 0l-8.47-7.53h17.494zM.833 16.667V4.077l8.337 7.41a1.248 1.248 0 001.66 0l8.337-7.41v12.59H.833z",
    fill: "#333"
  })));
};
export default SvgMyInbox;